import React, { useEffect } from 'react'
import { Grid } from '@mui/material'

import EditMappingDrawer from 'Pages/Admin/AdminMapping/EditDrawer'
import CreateAdminMappingButton from 'Pages/Admin/AdminMapping/CreateButton'
import { MAPPING_TYPE } from 'Pages/Admin/AdminMapping/@constants'
import { clearSignals } from 'Pages/Admin/AdminMapping/@signals'
import AdminMappingTable from 'Pages/Admin/AdminMapping/Table'


export default function AdminMappingPageContent() {

	useEffect(() => {
		return () => {
			clearSignals()
		}
	}, [])

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<EditMappingDrawer/>
		</Grid>
		<Grid item xs={12}>
			<CreateAdminMappingButton path={MAPPING_TYPE.ACRISS}/>
		</Grid>
		<Grid item xs={12} sx={{ height: 650 }}>
			<AdminMappingTable path={MAPPING_TYPE.ACRISS}/>
		</Grid>
		<Grid item xs={12}>
			<CreateAdminMappingButton path={MAPPING_TYPE.CATEGORY}/>
		</Grid>
		<Grid item xs={12}>
			<AdminMappingTable path={MAPPING_TYPE.CATEGORY}/>
		</Grid>
	</Grid>
}